<template>
  <div class="login-content">
    <div class="qrcode-box" v-loading="loading">
      <el-image v-if="unid" class="qrcode-img" :src="qrcode" fit="cover"></el-image>
      <div v-if="loginStatus == 1" class="mask login-success">
        <div class="txt">登录成功,跳转中...</div>
      </div>
      <div v-if="loginStatus == 2" class="mask login-failed">
        <div @click="getQrcode" class="txt">登录失败</div>
        <div @click="getQrcode" class="iconfont icon-refresh v-ml-5"></div>
      </div>
      <div v-if="loginStatus == 3" class="mask login-timeout">
        <div @click="getQrcode" class="txt">二维码失效</div>
        <div @click="getQrcode" class="iconfont icon-refresh v-ml-5"></div>
      </div>
    </div>
    <login-by-mobile />
  </div>
</template>

<script>
import cookie from '@/api/cookie';
import loginByMobile from './login-by-mobile';
export default {
  components: { loginByMobile },

  data() {
    return {
      isShowLogin: false,
      loading: false,
      loginTimerLoading: false, //二维码登录轮询
      loginTimeTotal: 0, //二维码登录轮询
      unid: '',
      qrcode: '',
      loginStatus: 0, //1登录成功 2登录失败 3二维码失效
      mobile: '',
    };
  },

  inject: ['redirectProject', 'getLoginStatus'],

  created() {
    this.getQrcode();
  },

  destroyed() {
    this.loginStatus = 1;
    this.loginTimeTotal = 300;
  },

  methods: {
    //获取登录二维码
    async getQrcode() {
      this.loading = true;
      try {
        let res = await this.api.user.getLoginQrcode();
        this.qrcode = res.data.url;
        this.unid = res.data.unid;
        this.setLoginTimer();
        this.loginStatus = 0;
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
    },

    //二维码登录轮询
    setLoginTimer() {
      this.loginTimeTotal += 2;
      if (this.loginTimeTotal > 300) {
        this.loginStatus = 3;
        return;
      }

      setTimeout(() => {
        this.setLoginTimer();
        if (!this.loginTimerLoading && this.loginStatus == 0) {
          this.doLoginTimer();
        }
      }, 2000);
    },

    async doLoginTimer() {
      this.loginTimerLoading = true;
      try {
        let res = await this.api.user.isLogin({ unid: this.unid });
        if (res.data.code == 2) {
          this.loginStatus = 1;
          cookie.setToken(res.data['xx-token']);
          this.$store.commit('user/SET_TOKEN', res.data['xx-token']);
          let loginStatus = await this.getLoginStatus();
          if (loginStatus == 1) {
            this.redirectProject();
          }
        }
      } catch (e) {
        this.loginStatus = 2;
      }
      this.loginTimerLoading = false;
    },
  },
};
</script>

<style scoped lang="scss">
.login-content {
  position: absolute;
  top: 125px;
  left: 480px;
  width: 354px;
}

.login-btn-box {
  margin-top: 50px;
}

input::-webkit-input-placeholder {
  font-size: 14px;
  color: #cacaca;
}

.login-btn {
  display: block;
  width: 100%;
  font-size: 16px;
  letter-spacing: 6px;
  background: linear-gradient(180deg, rgba(62, 144, 255, 1) 0%, rgba(21, 113, 238, 1) 100%);
  border-radius: 35px;
  border: 0;
  height: 50px;

  &:hover,
  &:focus {
    background: linear-gradient(180deg, rgba(62, 144, 255, 1) 0%, rgba(21, 113, 238, 1) 100%);
  }
}

.login-box /deep/ .form-control .el-input__inner {
  border-width: 0;
  border-radius: 40px;
  padding-left: 30px;
  height: 50px;
  background: #f6f6f6;
}

.qrcode-box {
  position: relative;
  border: 1px solid #eee;
  width: 260px;
  height: 260px;
  margin: 0 auto;
}

.qrcode-img {
  display: block;
  width: 100%;
  height: 100%;
}

.qrcode-box .mask {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.qrcode-box .mask .txt {
  cursor: pointer;
}

.qrcode-box .mask .iconfont {
  cursor: pointer;
}
</style>
